import { render, staticRenderFns } from "./flow.vue?vue&type=template&id=c03fb8fc&scoped=true&"
import script from "./flow.vue?vue&type=script&lang=js&"
export * from "./flow.vue?vue&type=script&lang=js&"
import style0 from "./flow.vue?vue&type=style&index=0&lang=css&"
import style1 from "./flow.vue?vue&type=style&index=1&id=c03fb8fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c03fb8fc",
  null
  
)

export default component.exports